import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { OverviewModelInterface } from '../models/overview';

export interface OverviewState {
  model: OverviewModelInterface;
}

const initialState: OverviewState = {
  model: {
    flights: [],
    checkedInPassengers: [],
    route: 'ck_overview',
    encryptedDeeplink: null,
    showPrintAll: false,
    bpEnabled: false,
    mbpEnabled: true,
    allInOneBoardingPassUrl: '',
    retrievePassenger: {},
    pnrNumber: '',
    fullCkiProcess: false,
    single_pax_process: false,
    allmbp: '',
    emailSingle: '',
    messages: {},
    excludeFromLocalStorage: ['messages'],
    googleWalletSupportedLanguages: [
      'ar',
      'cs',
      'da',
      'de',
      'en',
      'es',
      'fi',
      'fr',
      'hr',
      'in',
      'it',
      'ja',
      'ko',
      'nl',
      'no',
      'pl',
      'pt-br',
      'ru',
      'sk',
      'sv',
      'th',
      'uk',
      'zh-cn', // default to zh
      'zh-tw',
    ],
    hasWifiCode: false,
    rentalCarsUrl: undefined,
    rentalCarsElUrl: undefined,
    sherpaConfig: {
      type: 'TRIP',
      url: '',
      options: {
        travelers: {},
        segments: {},
        placement: '',
      },
    },
    bookingUrl: '',
    getYourGuideConfig: {
      localeCode: '',
      iata: '',
      widgetUrl: '',
      scriptUrl: '',
    },
    promoBanners: [],
    notAvailableFlights: [],
  },
};

export const OverviewSlice = createSlice({
  name: 'overview',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    resetOverviewModel: (state) => {
      return initialState;
    },
    setOverviewModel: (state, action) => {
      state.model = action.payload;
    },
    setOverviewModelAttribute: (state, action: PayloadAction<{ key: string; value: any }>) => {
      const key = action.payload.key;
      const value = action.payload.value;
      Object.assign(state.model, { [key]: value });
    },
    setOverviewPaxAttribute: (
      state,
      action: PayloadAction<{ paxIdReference: number; key: string; value: any }>
    ) => {
      const paxIdReference = action.payload.paxIdReference;
      const key = action.payload.key;
      const value = action.payload.value;
      let pax = state.model.flights[0].passengers.find((x) => x.paxIdReference === paxIdReference);
      if (pax) {
        Object.assign(pax, { [key]: value });
      }
    },
    extendOverviewPaxAttribute: (
      state,
      action: PayloadAction<{
        id: number;
        object: any;
      }>
    ) => {
      const id = action.payload.id;
      const object = action.payload.object;
      let pax = state.model.flights[0].passengers.find((x) => x.paxIdReference === id);
      if (pax) {
        Object.assign(pax, object);
      }
    },
    setCheckinPassengers: (state, action) => {
      state.model.checkedInPassengers = action.payload;
    },
    resetMesages: (state) => {
      state.model.messages = null;
    },
  },
});

export const {
  setOverviewModel,
  setOverviewModelAttribute,
  setOverviewPaxAttribute,
  extendOverviewPaxAttribute,
  setCheckinPassengers,
  resetOverviewModel,
  resetMesages,
} = OverviewSlice.actions;

export const selectOverviewModel = (state: RootState) => state.overview.model;
export default OverviewSlice.reducer;
